import { useMediaQuery } from 'react-responsive';

const useDesktopMediaQuery = () =>
  useMediaQuery({ query: '(min-width: 1024px)' });

export { useDesktopMediaQuery };
